import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "index-view-container" }
const _hoisted_2 = { class: "index-header" }
const _hoisted_3 = { class: "d-flex my-4" }
const _hoisted_4 = { class: "index-sidebar" }
const _hoisted_5 = { class: "index-main ml-2 mr-10 rounded-lg" }

import HeaderBox from "@/components/index/HeaderBox.vue";
import SideBar from "@/components/index/SideBar.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'IndexView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(HeaderBox)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(SideBar)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_router_view)
      ])
    ])
  ]))
}
}

})